class h {
  constructor() {
    this.callbacks = {};
  }
  on(l, ...s) {
    return this.callbacks[l] || (this.callbacks[l] = []), this.callbacks[l].push(...s), this;
  }
  off(l, s) {
    if (!this.callbacks[l])
      return null;
    const r = this.callbacks[l].slice(0);
    for (let c = 0; c < r.length; c++)
      s === r[c] && this.callbacks[l].splice(c, 1);
    return this;
  }
  trigger(l) {
    if (!this.callbacks[l.type])
      return null;
    const s = [...this.callbacks[l.type]], r = [];
    for (let c = s.length - 1; c >= 0; c--) {
      const t = s[c];
      try {
        t(l);
      } catch (a) {
        r.push(a);
      }
    }
    return r.length && console.error(`Draggable caught errors while triggering '${l.type}'`, r), this;
  }
}
export {
  h as default
};
